import DefaultApiService from "./default";

const BASE = "SLN/Supplier/SupplierEquipmentProducts";

const wrap = (res, fallback) => ({
  ok: res?.isSuccess !== false && res?.IsSuccess !== false,
  message: res?.message || res?.Message || "",
  data: res?.data ?? res?.Data ?? fallback,
});

const SupplierEquipmentProductsApi = {
  getMyProducts: async () =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetMyProducts`), []),

  linkToMaster: async (payload) =>
    wrap(await DefaultApiService.postApi(`${BASE}/LinkToMaster`, payload)),

  updateCommercialInfo: async (payload) =>
    wrap(await DefaultApiService.postApi(`${BASE}/UpdateCommercialInfo`, payload)),

  submitNewEquipmentRequest: async (payload) =>
    wrap(
      await DefaultApiService.postApi(`${BASE}/SubmitNewEquipmentRequest`, payload)
    ),
};

export default SupplierEquipmentProductsApi;
